import axios from "axios";
import config from "../config";

const endPoint = "/shipping/service/v1";

class TrackingService {
	async find(orderId) {
		const response = await axios.get(`${endPoint}/tracks/${orderId}`);
		const { data } = response;
		return data.results;
	}
}

export default new TrackingService();
